// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, useMutation, type UseMutationOptions, useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { client } from '../client.gen';
import { addContactToView, archiveViews, buyViewPhoneNumber, companyRegistrySearch, countContacts, createCompany, createContact, createHoliday, createPublishedReview, createReviewInvitation, deleteHoliday, deleteProof, getCertificate, getCity, getCompany, getContact, getLegalForms, getNetwork, getPhoneNumberStatus, getProof, getSolicitation, getView, importSubscriptionsFromZoho, listContacts, listHolidays, listReviews, listViews, type Options, publishReview, refuseReview, replacePhoneNumber, spamReview, submitProof, syncAllCompaniesWithPennylane, syncCompanyWithPennylane, syncSpatialReviews, updateCompany, updateContact, updateHoliday, updatePresentation, updateReviewPresentations, updateView, validateProof } from '../sdk.gen';
import type { AddContactToViewData, ArchiveViewsData, BuyViewPhoneNumberData, CompanyRegistrySearchData, CompanyRegistrySearchResponse, CountContactsData, CountContactsResponse2, CreateCompanyData, CreateCompanyResponse, CreateContactData, CreateContactResponse, CreateHolidayData, CreatePublishedReviewData, CreateReviewInvitationData, DeleteHolidayData, DeleteProofData, GetCertificateData, GetCertificateResponse, GetCityData, GetCityResponse, GetCompanyData, GetCompanyResponse, GetContactData, GetContactResponse, GetLegalFormsData, GetLegalFormsResponse, GetNetworkData, GetNetworkResponse, GetPhoneNumberStatusData, GetPhoneNumberStatusResponse, GetProofData, GetProofResponse, GetSolicitationData, GetSolicitationResponse, GetViewData, GetViewResponse, ImportSubscriptionsFromZohoData, ImportSubscriptionsFromZohoResponse2, ListContactsData, ListContactsResponse2, ListHolidaysData, ListHolidaysResponse2, ListReviewsData, ListReviewsResponse2, ListViewsData, ListViewsResponse2, PublishReviewData, RefuseReviewData, ReplacePhoneNumberData, SpamReviewData, SubmitProofData, SyncAllCompaniesWithPennylaneData, SyncAllCompaniesWithPennylaneResponse2, SyncCompanyWithPennylaneData, SyncSpatialReviewsData, UpdateCompanyData, UpdateContactData, UpdateHolidayData, UpdatePresentationData, UpdateReviewPresentationsData, UpdateViewData, ValidateProofData } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getSolicitationQueryKey = (options: Options<GetSolicitationData>) => createQueryKey('getSolicitation', options);

/**
 * Get a solicitation by id
 */
export const getSolicitationOptions = (options: Options<GetSolicitationData>) => queryOptions<GetSolicitationResponse, AxiosError<DefaultError>, GetSolicitationResponse, ReturnType<typeof getSolicitationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSolicitation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSolicitationQueryKey(options)
});

/**
 * Get a solicitation by id
 */
export const useGetSolicitation = (options: Options<GetSolicitationData>) => useQuery(getSolicitationOptions(options));

export const listViewsQueryKey = (options?: Options<ListViewsData>) => createQueryKey('listViews', options);

/**
 * List views
 */
export const listViewsOptions = (options?: Options<ListViewsData>) => queryOptions<ListViewsResponse2, AxiosError<DefaultError>, ListViewsResponse2, ReturnType<typeof listViewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listViews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listViewsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listViewsInfiniteQueryKey = (options?: Options<ListViewsData>): QueryKey<Options<ListViewsData>> => createQueryKey('listViews', options, true);

/**
 * List views
 */
export const listViewsInfiniteOptions = (options?: Options<ListViewsData>) => infiniteQueryOptions<ListViewsResponse2, AxiosError<DefaultError>, InfiniteData<ListViewsResponse2>, QueryKey<Options<ListViewsData>>, number | Pick<QueryKey<Options<ListViewsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListViewsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listViews({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listViewsInfiniteQueryKey(options)
});

/**
 * List views
 */
export const useListViews = (options?: Options<ListViewsData>) => useQuery(listViewsOptions(options));

export const getViewQueryKey = (options: Options<GetViewData>) => createQueryKey('getView', options);

/**
 * Get a view
 */
export const getViewOptions = (options: Options<GetViewData>) => queryOptions<GetViewResponse, AxiosError<DefaultError>, GetViewResponse, ReturnType<typeof getViewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getView({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getViewQueryKey(options)
});

/**
 * Get a view
 */
export const useGetView = (options: Options<GetViewData>) => useQuery(getViewOptions(options));

/**
 * Update a view
 */
export const updateViewMutation = (options?: Partial<Options<UpdateViewData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdateViewData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdateViewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateView({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a view
 */
export const useUpdateView = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdateViewData>>, 'mutationFn'>>) => useMutation({ ...updateViewMutation(), ...mutationOptions });

/**
 * Archive views
 */
export const archiveViewsMutation = (options?: Partial<Options<ArchiveViewsData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<ArchiveViewsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<ArchiveViewsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await archiveViews({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive views
 */
export const useArchiveViews = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<ArchiveViewsData>>, 'mutationFn'>>) => useMutation({ ...archiveViewsMutation(), ...mutationOptions });

/**
 * Add a contact to a view
 */
export const addContactToViewMutation = (options?: Partial<Options<AddContactToViewData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<AddContactToViewData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<AddContactToViewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addContactToView({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add a contact to a view
 */
export const useAddContactToView = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<AddContactToViewData>>, 'mutationFn'>>) => useMutation({ ...addContactToViewMutation(), ...mutationOptions });

/**
 * Buy phone numbers for a view
 */
export const buyViewPhoneNumberMutation = (options?: Partial<Options<BuyViewPhoneNumberData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<BuyViewPhoneNumberData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<BuyViewPhoneNumberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await buyViewPhoneNumber({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Buy phone numbers for a view
 */
export const useBuyViewPhoneNumber = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<BuyViewPhoneNumberData>>, 'mutationFn'>>) => useMutation({ ...buyViewPhoneNumberMutation(), ...mutationOptions });

export const listHolidaysQueryKey = (options?: Options<ListHolidaysData>) => createQueryKey('listHolidays', options);

/**
 * List holidays
 */
export const listHolidaysOptions = (options?: Options<ListHolidaysData>) => queryOptions<ListHolidaysResponse2, AxiosError<DefaultError>, ListHolidaysResponse2, ReturnType<typeof listHolidaysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listHolidays({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listHolidaysQueryKey(options)
});

export const listHolidaysInfiniteQueryKey = (options?: Options<ListHolidaysData>): QueryKey<Options<ListHolidaysData>> => createQueryKey('listHolidays', options, true);

/**
 * List holidays
 */
export const listHolidaysInfiniteOptions = (options?: Options<ListHolidaysData>) => infiniteQueryOptions<ListHolidaysResponse2, AxiosError<DefaultError>, InfiniteData<ListHolidaysResponse2>, QueryKey<Options<ListHolidaysData>>, number | Pick<QueryKey<Options<ListHolidaysData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListHolidaysData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listHolidays({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listHolidaysInfiniteQueryKey(options)
});

/**
 * List holidays
 */
export const useListHolidays = (options?: Options<ListHolidaysData>) => useQuery(listHolidaysOptions(options));

/**
 * Create a holiday
 */
export const createHolidayMutation = (options?: Partial<Options<CreateHolidayData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<CreateHolidayData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<CreateHolidayData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createHoliday({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a holiday
 */
export const useCreateHoliday = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<CreateHolidayData>>, 'mutationFn'>>) => useMutation({ ...createHolidayMutation(), ...mutationOptions });

/**
 * Delete a holiday
 */
export const deleteHolidayMutation = (options?: Partial<Options<DeleteHolidayData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeleteHolidayData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeleteHolidayData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteHoliday({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a holiday
 */
export const useDeleteHoliday = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeleteHolidayData>>, 'mutationFn'>>) => useMutation({ ...deleteHolidayMutation(), ...mutationOptions });

/**
 * Update a holiday
 */
export const updateHolidayMutation = (options?: Partial<Options<UpdateHolidayData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdateHolidayData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdateHolidayData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateHoliday({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a holiday
 */
export const useUpdateHoliday = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdateHolidayData>>, 'mutationFn'>>) => useMutation({ ...updateHolidayMutation(), ...mutationOptions });

export const listContactsQueryKey = (options?: Options<ListContactsData>) => createQueryKey('listContacts', options);

/**
 * List contacts
 */
export const listContactsOptions = (options?: Options<ListContactsData>) => queryOptions<ListContactsResponse2, AxiosError<DefaultError>, ListContactsResponse2, ReturnType<typeof listContactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContactsQueryKey(options)
});

export const listContactsInfiniteQueryKey = (options?: Options<ListContactsData>): QueryKey<Options<ListContactsData>> => createQueryKey('listContacts', options, true);

/**
 * List contacts
 */
export const listContactsInfiniteOptions = (options?: Options<ListContactsData>) => infiniteQueryOptions<ListContactsResponse2, AxiosError<DefaultError>, InfiniteData<ListContactsResponse2>, QueryKey<Options<ListContactsData>>, number | Pick<QueryKey<Options<ListContactsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListContactsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listContacts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContactsInfiniteQueryKey(options)
});

/**
 * List contacts
 */
export const useListContacts = (options?: Options<ListContactsData>) => useQuery(listContactsOptions(options));

/**
 * Create a contact
 */
export const createContactMutation = (options?: Partial<Options<CreateContactData>>): UseMutationOptions<CreateContactResponse, AxiosError<DefaultError>, Options<CreateContactData>> => {
    const mutationOptions: UseMutationOptions<CreateContactResponse, AxiosError<DefaultError>, Options<CreateContactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createContact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a contact
 */
export const useCreateContact = (mutationOptions?: Partial<Omit<UseMutationOptions<CreateContactResponse, AxiosError<DefaultError>, Options<CreateContactData>>, 'mutationFn'>>) => useMutation({ ...createContactMutation(), ...mutationOptions });

export const countContactsQueryKey = (options?: Options<CountContactsData>) => createQueryKey('countContacts', options);

/**
 * Count contacts
 */
export const countContactsOptions = (options?: Options<CountContactsData>) => queryOptions<CountContactsResponse2, AxiosError<DefaultError>, CountContactsResponse2, ReturnType<typeof countContactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await countContacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: countContactsQueryKey(options)
});

/**
 * Count contacts
 */
export const useCountContacts = (options?: Options<CountContactsData>) => useQuery(countContactsOptions(options));

export const getContactQueryKey = (options: Options<GetContactData>) => createQueryKey('getContact', options);

/**
 * Get a contact
 */
export const getContactOptions = (options: Options<GetContactData>) => queryOptions<GetContactResponse, AxiosError<DefaultError>, GetContactResponse, ReturnType<typeof getContactQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContact({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContactQueryKey(options)
});

/**
 * Get a contact
 */
export const useGetContact = (options: Options<GetContactData>) => useQuery(getContactOptions(options));

/**
 * Update a contact
 */
export const updateContactMutation = (options?: Partial<Options<UpdateContactData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdateContactData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdateContactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateContact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a contact
 */
export const useUpdateContact = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdateContactData>>, 'mutationFn'>>) => useMutation({ ...updateContactMutation(), ...mutationOptions });

/**
 * Update presentation
 */
export const updatePresentationMutation = (options?: Partial<Options<UpdatePresentationData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdatePresentationData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdatePresentationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePresentation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update presentation
 */
export const useUpdatePresentation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdatePresentationData>>, 'mutationFn'>>) => useMutation({ ...updatePresentationMutation(), ...mutationOptions });

/**
 * Replace phone number
 */
export const replacePhoneNumberMutation = (options?: Partial<Options<ReplacePhoneNumberData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<ReplacePhoneNumberData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<ReplacePhoneNumberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await replacePhoneNumber({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Replace phone number
 */
export const useReplacePhoneNumber = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<ReplacePhoneNumberData>>, 'mutationFn'>>) => useMutation({ ...replacePhoneNumberMutation(), ...mutationOptions });

export const getPhoneNumberStatusQueryKey = (options: Options<GetPhoneNumberStatusData>) => createQueryKey('getPhoneNumberStatus', options);

/**
 * Get phone number status
 */
export const getPhoneNumberStatusOptions = (options: Options<GetPhoneNumberStatusData>) => queryOptions<GetPhoneNumberStatusResponse, AxiosError<DefaultError>, GetPhoneNumberStatusResponse, ReturnType<typeof getPhoneNumberStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPhoneNumberStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPhoneNumberStatusQueryKey(options)
});

/**
 * Get phone number status
 */
export const useGetPhoneNumberStatus = (options: Options<GetPhoneNumberStatusData>) => useQuery(getPhoneNumberStatusOptions(options));

export const getNetworkQueryKey = (options: Options<GetNetworkData>) => createQueryKey('getNetwork', options);

/**
 * Get a network
 */
export const getNetworkOptions = (options: Options<GetNetworkData>) => queryOptions<GetNetworkResponse, AxiosError<DefaultError>, GetNetworkResponse, ReturnType<typeof getNetworkQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getNetwork({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getNetworkQueryKey(options)
});

/**
 * Get a network
 */
export const useGetNetwork = (options: Options<GetNetworkData>) => useQuery(getNetworkOptions(options));

export const getCityQueryKey = (options: Options<GetCityData>) => createQueryKey('getCity', options);

/**
 * Get a city
 */
export const getCityOptions = (options: Options<GetCityData>) => queryOptions<GetCityResponse, AxiosError<DefaultError>, GetCityResponse, ReturnType<typeof getCityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCityQueryKey(options)
});

/**
 * Get a city
 */
export const useGetCity = (options: Options<GetCityData>) => useQuery(getCityOptions(options));

export const listReviewsQueryKey = (options?: Options<ListReviewsData>) => createQueryKey('listReviews', options);

/**
 * List reviews
 */
export const listReviewsOptions = (options?: Options<ListReviewsData>) => queryOptions<ListReviewsResponse2, AxiosError<DefaultError>, ListReviewsResponse2, ReturnType<typeof listReviewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listReviews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listReviewsQueryKey(options)
});

export const listReviewsInfiniteQueryKey = (options?: Options<ListReviewsData>): QueryKey<Options<ListReviewsData>> => createQueryKey('listReviews', options, true);

/**
 * List reviews
 */
export const listReviewsInfiniteOptions = (options?: Options<ListReviewsData>) => infiniteQueryOptions<ListReviewsResponse2, AxiosError<DefaultError>, InfiniteData<ListReviewsResponse2>, QueryKey<Options<ListReviewsData>>, number | Pick<QueryKey<Options<ListReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listReviews({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listReviewsInfiniteQueryKey(options)
});

/**
 * List reviews
 */
export const useListReviews = (options?: Options<ListReviewsData>) => useQuery(listReviewsOptions(options));

export const getCertificateQueryKey = (options: Options<GetCertificateData>) => createQueryKey('getCertificate', options);

/**
 * Get the review certificate of a presentation
 */
export const getCertificateOptions = (options: Options<GetCertificateData>) => queryOptions<GetCertificateResponse, AxiosError<DefaultError>, GetCertificateResponse, ReturnType<typeof getCertificateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCertificate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCertificateQueryKey(options)
});

/**
 * Get the review certificate of a presentation
 */
export const useGetCertificate = (options: Options<GetCertificateData>) => useQuery(getCertificateOptions(options));

/**
 * Create a directly published review
 */
export const createPublishedReviewMutation = (options?: Partial<Options<CreatePublishedReviewData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<CreatePublishedReviewData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<CreatePublishedReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPublishedReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a directly published review
 */
export const useCreatePublishedReview = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<CreatePublishedReviewData>>, 'mutationFn'>>) => useMutation({ ...createPublishedReviewMutation(), ...mutationOptions });

/**
 * Publish review
 */
export const publishReviewMutation = (options?: Partial<Options<PublishReviewData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<PublishReviewData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<PublishReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publishReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Publish review
 */
export const usePublishReview = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<PublishReviewData>>, 'mutationFn'>>) => useMutation({ ...publishReviewMutation(), ...mutationOptions });

/**
 * Refuse review
 */
export const refuseReviewMutation = (options?: Partial<Options<RefuseReviewData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<RefuseReviewData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<RefuseReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await refuseReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refuse review
 */
export const useRefuseReview = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<RefuseReviewData>>, 'mutationFn'>>) => useMutation({ ...refuseReviewMutation(), ...mutationOptions });

/**
 * Spam review
 */
export const spamReviewMutation = (options?: Partial<Options<SpamReviewData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<SpamReviewData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<SpamReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await spamReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Spam review
 */
export const useSpamReview = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<SpamReviewData>>, 'mutationFn'>>) => useMutation({ ...spamReviewMutation(), ...mutationOptions });

/**
 * Update the presentations a review is visible on: makes it visible on other presentations of
 * its company, removes it from some, or moves it
 */
export const updateReviewPresentationsMutation = (options?: Partial<Options<UpdateReviewPresentationsData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdateReviewPresentationsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdateReviewPresentationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateReviewPresentations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update the presentations a review is visible on: makes it visible on other presentations of
 * its company, removes it from some, or moves it
 */
export const useUpdateReviewPresentations = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdateReviewPresentationsData>>, 'mutationFn'>>) => useMutation({ ...updateReviewPresentationsMutation(), ...mutationOptions });

/**
 * Delete a proof document
 */
export const deleteProofMutation = (options?: Partial<Options<DeleteProofData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeleteProofData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeleteProofData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteProof({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a proof document
 */
export const useDeleteProof = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeleteProofData>>, 'mutationFn'>>) => useMutation({ ...deleteProofMutation(), ...mutationOptions });

export const getProofQueryKey = (options: Options<GetProofData>) => createQueryKey('getProof', options);

/**
 * Get the proof document for a review.
 * Returns `null` when no proof has been submitted yet.
 */
export const getProofOptions = (options: Options<GetProofData>) => queryOptions<GetProofResponse, AxiosError<DefaultError>, GetProofResponse, ReturnType<typeof getProofQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProof({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProofQueryKey(options)
});

/**
 * Get the proof document for a review.
 * Returns `null` when no proof has been submitted yet.
 */
export const useGetProof = (options: Options<GetProofData>) => useQuery(getProofOptions(options));

/**
 * Submit a proof document for a review
 */
export const submitProofMutation = (options?: Partial<Options<SubmitProofData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<SubmitProofData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<SubmitProofData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitProof({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit a proof document for a review
 */
export const useSubmitProof = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<SubmitProofData>>, 'mutationFn'>>) => useMutation({ ...submitProofMutation(), ...mutationOptions });

/**
 * Validate a proof document
 */
export const validateProofMutation = (options?: Partial<Options<ValidateProofData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<ValidateProofData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<ValidateProofData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateProof({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Validate a proof document
 */
export const useValidateProof = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<ValidateProofData>>, 'mutationFn'>>) => useMutation({ ...validateProofMutation(), ...mutationOptions });

/**
 * Synchronize spatial indexing for all reviews
 */
export const syncSpatialReviewsMutation = (options?: Partial<Options<SyncSpatialReviewsData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<SyncSpatialReviewsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<SyncSpatialReviewsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await syncSpatialReviews({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Synchronize spatial indexing for all reviews
 */
export const useSyncSpatialReviews = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<SyncSpatialReviewsData>>, 'mutationFn'>>) => useMutation({ ...syncSpatialReviewsMutation(), ...mutationOptions });

/**
 * Create a review invitation
 */
export const createReviewInvitationMutation = (options?: Partial<Options<CreateReviewInvitationData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<CreateReviewInvitationData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<CreateReviewInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createReviewInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a review invitation
 */
export const useCreateReviewInvitation = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<CreateReviewInvitationData>>, 'mutationFn'>>) => useMutation({ ...createReviewInvitationMutation(), ...mutationOptions });

/**
 * Temporary route for Pennylane migration
 */
export const syncAllCompaniesWithPennylaneMutation = (options?: Partial<Options<SyncAllCompaniesWithPennylaneData>>): UseMutationOptions<SyncAllCompaniesWithPennylaneResponse2, AxiosError<DefaultError>, Options<SyncAllCompaniesWithPennylaneData>> => {
    const mutationOptions: UseMutationOptions<SyncAllCompaniesWithPennylaneResponse2, AxiosError<DefaultError>, Options<SyncAllCompaniesWithPennylaneData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await syncAllCompaniesWithPennylane({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Temporary route for Pennylane migration
 */
export const useSyncAllCompaniesWithPennylane = (mutationOptions?: Partial<Omit<UseMutationOptions<SyncAllCompaniesWithPennylaneResponse2, AxiosError<DefaultError>, Options<SyncAllCompaniesWithPennylaneData>>, 'mutationFn'>>) => useMutation({ ...syncAllCompaniesWithPennylaneMutation(), ...mutationOptions });

/**
 * Temporary route for Pennylane migration
 */
export const syncCompanyWithPennylaneMutation = (options?: Partial<Options<SyncCompanyWithPennylaneData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<SyncCompanyWithPennylaneData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<SyncCompanyWithPennylaneData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await syncCompanyWithPennylane({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Temporary route for Pennylane migration
 */
export const useSyncCompanyWithPennylane = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<SyncCompanyWithPennylaneData>>, 'mutationFn'>>) => useMutation({ ...syncCompanyWithPennylaneMutation(), ...mutationOptions });

export const companyRegistrySearchQueryKey = (options?: Options<CompanyRegistrySearchData>) => createQueryKey('companyRegistrySearch', options);

/**
 * Search companies in registry
 */
export const companyRegistrySearchOptions = (options?: Options<CompanyRegistrySearchData>) => queryOptions<CompanyRegistrySearchResponse, AxiosError<DefaultError>, CompanyRegistrySearchResponse, ReturnType<typeof companyRegistrySearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companyRegistrySearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companyRegistrySearchQueryKey(options)
});

/**
 * Search companies in registry
 */
export const useCompanyRegistrySearch = (options?: Options<CompanyRegistrySearchData>) => useQuery(companyRegistrySearchOptions(options));

export const getCompanyQueryKey = (options: Options<GetCompanyData>) => createQueryKey('getCompany', options);

/**
 * Get a company
 */
export const getCompanyOptions = (options: Options<GetCompanyData>) => queryOptions<GetCompanyResponse, AxiosError<DefaultError>, GetCompanyResponse, ReturnType<typeof getCompanyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCompany({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCompanyQueryKey(options)
});

/**
 * Get a company
 */
export const useGetCompany = (options: Options<GetCompanyData>) => useQuery(getCompanyOptions(options));

/**
 * Update a company
 */
export const updateCompanyMutation = (options?: Partial<Options<UpdateCompanyData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdateCompanyData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdateCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a company
 */
export const useUpdateCompany = (mutationOptions?: Partial<Omit<UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UpdateCompanyData>>, 'mutationFn'>>) => useMutation({ ...updateCompanyMutation(), ...mutationOptions });

export const getLegalFormsQueryKey = (options?: Options<GetLegalFormsData>) => createQueryKey('getLegalForms', options);

/**
 * Get legal form list
 */
export const getLegalFormsOptions = (options?: Options<GetLegalFormsData>) => queryOptions<GetLegalFormsResponse, AxiosError<DefaultError>, GetLegalFormsResponse, ReturnType<typeof getLegalFormsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLegalForms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLegalFormsQueryKey(options)
});

/**
 * Get legal form list
 */
export const useGetLegalForms = (options?: Options<GetLegalFormsData>) => useQuery(getLegalFormsOptions(options));

/**
 * Create a company
 */
export const createCompanyMutation = (options?: Partial<Options<CreateCompanyData>>): UseMutationOptions<CreateCompanyResponse, AxiosError<DefaultError>, Options<CreateCompanyData>> => {
    const mutationOptions: UseMutationOptions<CreateCompanyResponse, AxiosError<DefaultError>, Options<CreateCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a company
 */
export const useCreateCompany = (mutationOptions?: Partial<Omit<UseMutationOptions<CreateCompanyResponse, AxiosError<DefaultError>, Options<CreateCompanyData>>, 'mutationFn'>>) => useMutation({ ...createCompanyMutation(), ...mutationOptions });

/**
 * Temporary route for the Zoho migration: creates the subscriptions of the
 * views from their Zoho recurring invoices (active, expired and stopped),
 * exported by the zoho stack. Sent in batches by the admin.
 */
export const importSubscriptionsFromZohoMutation = (options?: Partial<Options<ImportSubscriptionsFromZohoData>>): UseMutationOptions<ImportSubscriptionsFromZohoResponse2, AxiosError<DefaultError>, Options<ImportSubscriptionsFromZohoData>> => {
    const mutationOptions: UseMutationOptions<ImportSubscriptionsFromZohoResponse2, AxiosError<DefaultError>, Options<ImportSubscriptionsFromZohoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await importSubscriptionsFromZoho({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Temporary route for the Zoho migration: creates the subscriptions of the
 * views from their Zoho recurring invoices (active, expired and stopped),
 * exported by the zoho stack. Sent in batches by the admin.
 */
export const useImportSubscriptionsFromZoho = (mutationOptions?: Partial<Omit<UseMutationOptions<ImportSubscriptionsFromZohoResponse2, AxiosError<DefaultError>, Options<ImportSubscriptionsFromZohoData>>, 'mutationFn'>>) => useMutation({ ...importSubscriptionsFromZohoMutation(), ...mutationOptions });
